import { __module as r } from "../../_virtual/index2.mjs";
import { __require as e } from "./cjs/react-is.production.min.mjs";
import { __require as t } from "./cjs/react-is.development.mjs";
(function(o) {
  process.env.NODE_ENV === "production" ? o.exports = e() : o.exports = t();
})(r);
//# sourceMappingURL=index.mjs.map
